export default __webpack_public_path__ + "static/media/feature_1.0801ef84.png";